import React from 'react';
import MenuDashboard from "./Menu";
import HeaderMember from "./HeaderMember";
import "./css/dashboard.css";
import axios from 'axios';
import moment from 'moment';
import 'moment-timezone';
import 'moment/locale/fr';
import {API_URI} from "../../constant/Config"
import {t, DATE_FORMAT} from '../../constant/i18n';
import {NATIONALITIES, COUNTRIES_ISO, getCountryLabel, filterCountryOption, countrySearchText} from '../../constant/countries';

import {
    UserOutlined,
    SettingFilled,
    SmileOutlined,
    SyncOutlined,
    LoadingOutlined,
    SolutionOutlined,
    RadiusUprightOutlined,
    ExclamationCircleOutlined,
} from '@ant-design/icons';

import {
    Form,
    Input,
    Button,
    Checkbox,
    Row,
    Col,
    Typography,
    Divider,
    Steps,
    Select,
    DatePicker,
    Space,
    Layout,
    notification,
} from 'antd';
import {FooterApps} from "../order/inc/FooterApps";


const {Title, Text, Link} = Typography;
const {Step} = Steps;
const layout = {
    labelCol: {span: 5},
    wrapperCol: {span: 19},
};
const tailLayout = {
    wrapperCol: {offset: 5, span: 19},
};
const {Option} = Select;


export default class Profil extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            dataMembre: false,
            passeInsert: false,
        }
    }

    onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };

    componentDidMount = async () => {

        var token = localStorage.getItem('membre_token');
        await axios.get(API_URI + '/api_member/data_member', {
            headers: {
                'Authorization': token
            }
        })
            .then(res => {
                this.setState({dataMembre: res.data.data_membre});
            })
    }

    onFinish = async (value) => {
        var token = localStorage.getItem('membre_token');
        const res = await axios.post(API_URI + '/api_member/update_member', value, {
            headers: {
                'Authorization': token
            }
        }).then(res => {
            if (res.data.response === 'no') {
                notification.open({
                    message: res.data.title,
                    description: res.data.msg,
                    icon: <ExclamationCircleOutlined style={{color: '#108ee9'}}/>,
                });
            } else {
                notification.open({
                    message: res.data.title,
                    description: res.data.msg,
                    icon: <SmileOutlined style={{color: '#108ee9'}}/>,
                });
            }
        });


    }

    selectDate = async (e, dateString) => {
        console.log(dateString)
        this.setState({
            age: e,
        })
    }

    testPassword = (password) => {
        this.setState({passeInsert: true});
        var passValue = password.target.value;

        if(passValue.length >= 8) {
            return true;
        }else{
            return false;
        }
    }

    render() {

        if (this.state.dataMembre) {
            //console.log(this.state.dataMembre.ageString)
            return (
                <Layout>
                    <HeaderMember/>
                    <Layout>
                        <MenuDashboard/>
                        <Layout>
                            <div className="contentBox">
                                <Title>{t('profil.title')}</Title>
                                <Text>{t('profil.desc')}</Text>
                                <Divider/>
                                <Form
                                    {...layout}
                                    name="basic"
                                    initialValues={{remember: true}}
                                    onFinish={this.onFinish}
                                    onFinishFailed={this.onFinishFailed}
                                    className="formIdent"
                                >

                                    <Form.Item
                                        label={t('passport.civility')}
                                        name="cv"
                                        rules={[{required: true, message: t('profil.usernameRequired')}]}
                                        initialValue={this.state.dataMembre.cv}
                                    >
                                        <Select style={{width: 120}}>
                                            <option value="mr">{t('profil.mr')}</option>
                                            <option value="mme">{t('profil.mme')}</option>
                                        </Select>

                                    </Form.Item>

                                    <Form.Item
                                        label={t('common.email')}
                                        name="email"
                                        rules={[{type: 'email', required: true, message: t('orderFlight.missingInfoSingular')}]}
                                        initialValue={this.state.dataMembre.email}
                                    >
                                        <Input disabled/>
                                    </Form.Item>

                                    <Form.Item
                                        label={t('orderTransactions.lastName')}
                                        name="nom"
                                        rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                        initialValue={this.state.dataMembre.nom}
                                    >
                                        <Input disabled/>
                                    </Form.Item>

                                    <Form.Item
                                        label={t('orderTransactions.firstName')}
                                        name="prenom"
                                        rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                        initialValue={this.state.dataMembre.prenom}
                                    >
                                        <Input disabled/>
                                    </Form.Item>

                                    <Form.Item
                                        name="password"
                                        label={t('profil.password')}

                                        rules={[
                                            {
                                                required: this.state.passeInsert,
                                                message: t('profil.providePassword'),
                                            },
                                            (this.state.passeInsert?({getFieldValue}) => ({
                                                validator(_, value) {
                                                    if (value.length > 7) {
                                                        return Promise.resolve();
                                                    }

                                                    return Promise.reject(new Error(t('profil.passwordMinLength')));
                                                },
                                            }):false)
                                        ]}
                                        hasFeedback
                                    >
                                        <Input.Password onChange={(e) => {
                                            this.testPassword(e)
                                        }}/>
                                    </Form.Item>

                                    <Form.Item
                                        name="confirm"
                                        label={t('profil.confirmPassword')}
                                        dependencies={['password']}
                                        hasFeedback
                                        rules={[
                                            {
                                                required: this.state.passeInsert,
                                                message: t('profil.confirmPasswordRule'),
                                            },
                                            ({getFieldValue}) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue('password') === value) {
                                                        return Promise.resolve();
                                                    }

                                                    return Promise.reject(new Error(t('profil.samePasswordRule')));
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input.Password/>
                                    </Form.Item>

                                    <Form.Item
                                        label={t('profil.birthDate')}
                                        name="age"
                                        rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                        //initialValue={(this.state.dataMembre.ageString) ? moment(this.state.dataMembre.ageString, 'YYYY-MM-DD') : false}
                                        //initialValue={(this.state.dataMembre.ageString) ? moment(this.state.dataMembre.ageString+'T01:00:00', 'YYYY-MM-DDTHH:mm:ss') : false}
                                        initialValue={moment.unix(this.state.dataMembre.ageTs)}
                                    >
                                        <DatePicker
                                            format={DATE_FORMAT}
                                            style={{width: "100%"}}

                                        />
                                    </Form.Item>

                                    <Form.Item
                                        label={t('profil.nationality')}
                                        name="nation"
                                        rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                        initialValue={this.state.dataMembre.nation || undefined}
                                    >
                                        <Select
                                            style={{width: "100%"}}
                                            showSearch
                                            placeholder={t('common.searchPlaceholder')}
                                            notFoundContent={t('common.noResult')}
                                            filterOption={filterCountryOption}
                                        >
                                            {NATIONALITIES.map(c => (
                                                <option key={c.value} value={c.value} data-search={countrySearchText(c)}>{getCountryLabel(c)}</option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        label={t('profil.address')}
                                        name="adresse"
                                        rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                        initialValue={this.state.dataMembre.adresse}
                                    >
                                        <Input/>
                                    </Form.Item>

                                    <Form.Item
                                        label={t('orderTransactions.city')}
                                        name="ville"
                                        rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                        initialValue={this.state.dataMembre.ville}
                                    >
                                        <Input/>
                                    </Form.Item>

                                    <Form.Item
                                        label={t('profil.cp')}
                                        name="cp"
                                        rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                        initialValue={this.state.dataMembre.cp}
                                    >
                                        <Input/>
                                    </Form.Item>

                                    <Form.Item
                                        label={t('listeCmd.country')}
                                        name="pays"
                                        rules={[{required: true, message: t('profil.usernameRequired')}]}
                                        initialValue={this.state.dataMembre.pays || undefined}
                                    >
                                        <Select
                                            style={{width: "100%"}}
                                            showSearch
                                            placeholder={t('common.searchPlaceholder')}
                                            notFoundContent={t('common.noResult')}
                                            filterOption={filterCountryOption}
                                        >
                                            {COUNTRIES_ISO.map(c => (
                                                <option key={c.value} value={c.value} data-search={countrySearchText(c)}>{getCountryLabel(c)}</option>
                                            ))}
                                        </Select>

                                    </Form.Item>

                                    <Form.Item
                                        label={t('profil.mobilePhone')}
                                        name="telPort"
                                        rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                        initialValue={this.state.dataMembre.telPort}
                                    >
                                        <Input/>
                                    </Form.Item>

                                    <Form.Item
                                        label={t('profil.landline')}
                                        name="telFix"
                                        rules={[{required: false, message: t('orderFlight.missingInfoSingular')}]}
                                        initialValue={this.state.dataMembre.telFix}
                                    >
                                        <Input/>
                                    </Form.Item>


                                    <Form.Item
                                        label={t('profil.proSituation')}
                                        name="situationPro"
                                        rules={[{required: true, message: t('orderFlight.missingInfoSingular')}]}
                                        initialValue={this.state.dataMembre.situationPro}
                                    >
                                        <Input/>
                                    </Form.Item>
                                    <Form.Item
                                        label={t('profil.facebook')}
                                        name="gpMembrecolFb"
                                        rules={[{required: false, message: t('orderFlight.missingInfoSingular')}]}
                                        initialValue={this.state.dataMembre.gpMembrecolFb}
                                    >
                                        <Input/>
                                    </Form.Item>

                                    <Form.Item
                                        label={t('profil.remarks')}
                                        name="experienceUtile"
                                        rules={[{required: false, message: t('orderFlight.missingInfoSingular')}]}
                                        initialValue={this.state.dataMembre.experienceUtile}
                                    >
                                        <Input/>
                                    </Form.Item>

                                    <Form.Item
                                        {...tailLayout}
                                        name="consentSuiviEmail"
                                        valuePropName="checked"
                                        initialValue={this.state.dataMembre.consentSuiviEmail}
                                    >
                                        <Checkbox>
                                            {t('profil.emailTrackingConsent')}
                                        </Checkbox>
                                    </Form.Item>


                                    <Form.Item {...tailLayout}>
                                        <Button type="primary" htmlType="submit">
                                            {t('orderBlocDetails.validateInfo')}
                                        </Button>
                                    </Form.Item>
                                </Form>

                            </div>
                        </Layout>
                    </Layout>
                    <Divider dashed/>
                    <FooterApps/>
                </Layout>
            )
        } else {
            return (
                <Layout>
                    <HeaderMember/>
                    <Layout>
                        <MenuDashboard/>
                        <Layout>
                            <div className="contentBox">
                                {t('profil.loading')}
                            </div>
                        </Layout>
                    </Layout>
                </Layout>
            )
        }
    }
}



